// @ vendor
const { Promise } = require('es6-promise');
// @ constants
const actionTypes = require('constants/actionTypes');

function requestAccounts() {
    return function() {
        // (Andres): Let's keep returning an empty promise for backawards compatibility
        return Promise.resolve();
    }
}

function toggleIbanModal() {
    return {
        type: actionTypes.TOGGLE_IBAN_MODAL
    }
}

module.exports = {
    requestAccounts,
    toggleIbanModal
};
